import { apiClient } from "@api/client";
import { request, requestVoid } from "@api/request";
import type { components } from "@api/schema";

/** Mirrors brian's `VoiceprintOut`; change both together. */
interface VoiceprintStatus {
  status: components["schemas"]["VoiceprintStatus"];
  /** `status === "ready"`. */
  enrolled: boolean;
  sampleCount: number;
  sessionCount: number;
  pendingCount: number;
  modelVersion: string | null;
  updatedAt: string | null;
}

const toStatus = (
  s: components["schemas"]["VoiceprintOut"],
): VoiceprintStatus => ({
  status: s.status,
  enrolled: s.status === "ready",
  sampleCount: s.sample_count,
  sessionCount: s.session_count,
  pendingCount: s.pending_count,
  modelVersion: s.model_version,
  updatedAt: s.updated_at,
});

export const voiceprintClient = {
  getStatus: (): Promise<VoiceprintStatus> =>
    request(() => apiClient.GET("/voiceprints/me", {})).then(toStatus),

  /** `sessionKey` is per sitting, not per request: the backend groups samples by it. */
  uploadEnrollment: (file: Blob, sessionKey: string) =>
    request(() =>
      apiClient.POST("/voiceprints/me/enrollment", {
        // openapi-typescript types binary parts as `string`; the serializer is what crosses the wire.
        body: {
          file: file as unknown as string,
          session_key: sessionKey,
          consent: true,
        },
        bodySerializer: () => {
          const form = new FormData();
          form.append("file", file, "sample.wav");
          form.append("session_key", sessionKey);
          form.append("consent", "true");
          return form;
        },
      }),
    ),

  delete: (): Promise<void> =>
    requestVoid(() => apiClient.DELETE("/voiceprints/me", {})),
};
